import {
  extend,
  setOptions,
  TileEvent,
  TileLayer,
  TileLayerOptions,
} from 'leaflet';

export type Pixel = [number, number, number];

export type ColorizeFunction = (
  r: number,
  g: number,
  b: number,
  a: number
) => [number, number, number, number];

export type ColorizedTileLayerOptions = TileLayerOptions & {
  colorizer?: ColorizeFunction;
};

const ColorizedTileLayer = TileLayer.extend({
  initialize: function (url: string, options: ColorizedTileLayerOptions) {
    const mergedOptions: ColorizedTileLayerOptions = extend(
      {},
      TileLayer.prototype.options,
      {
        colorizer: (r: number, g: number, b: number, a: number) =>
          [r, g, b, a] as [number, number, number, number],
        crossOrigin: true,
      },
      options
    );
    // @todo get around any somehow?
    (TileLayer.prototype as any).initialize.call(this, url, mergedOptions);
    setOptions(this, mergedOptions);

    this.setColorizr(this.options.colorizer);

    const colorizeFct = this._colorize;
    this.on('tileload', (e: TileEvent) => {
      colorizeFct.call(this, e.tile);
    });
  },

  setColorizr: function (
    colorizeFunction: (r: number, g: number, b: number) => Pixel
  ) {
    if (!colorizeFunction || typeof colorizeFunction !== 'function') {
      throw (
        'The colorize option should be a function and return an object with at least one of "r", "g", "b", or "a" properties. Got:' +
        typeof colorizeFunction
      );
    } else {
      this.options.colorize = colorizeFunction;
    }

    this.redraw(true);
  },

  _createTile: function () {
    var tile = this._createTile(this);
    tile.crossOrigin = 'Anonymous';
    return tile;
  },

  _colorize: function (img: HTMLImageElement) {
    // todo remove
    // const t0 = performance.now();

    if (img.getAttribute('data-colorized')) return;

    img.crossOrigin = '';
    var canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext('2d')!; // @todo type assertion safe?
    ctx.drawImage(img, 0, 0);

    var imgd = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var pixels = imgd.data;

    for (var i = 0, n = pixels.length; i < n; i += 4) {
      var [r, g, b, a] = (this.options.colorize as ColorizeFunction)(
        pixels[i],
        pixels[i + 1],
        pixels[i + 2],
        pixels[i + 3]
      );
      pixels[i] = r;
      pixels[i + 1] = g;
      pixels[i + 2] = b;
      pixels[i + 3] = a;
    }

    ctx.putImageData(imgd, 0, 0);
    img.setAttribute('data-colorized', 'true');
    img.src = canvas.toDataURL();

    // todo remove
    // const t1 = performance.now();
    // console.log(`Colorizing tile took ${(t1 - t0).toFixed(1)}ms.`);
  },
});

export default ColorizedTileLayer;
